import type { KernelEntityRow } from '../../unifiedcommerce/framework';

type Props = { entities?: KernelEntityRow[] };

export function CommerceKernelPanel({ entities = [] }: Props) {
  return (
    <div className="space-y-2">
      {entities.map((e) => (
        <div key={e.entity} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{e.entity}</p>
          <div className="shrink-0 text-right">
            <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">{e.records.toLocaleString()}</p>
            <p className="text-xs text-success-600">{e.synced.toLocaleString()} synced</p>
          </div>
        </div>
      ))}
    </div>
  );
}
